import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SigaSeuPlanoService } from 'src/app/services/siga-seu-plano.service';
import { UtilService } from 'src/app/services/util.service';

declare var $: any;

@Component({
    selector: 'app-modal-siga-seu-plano',
    templateUrl: './modal-siga-seu-plano.component.html',
    styleUrls: ['./modal-siga-seu-plano.component.css'],
    imports: []
})
export class ModalSigaSeuPlanoComponent implements OnInit {

  aviso: any;
  arquivos: any[] = [];
  aceito: boolean = false;

  @Input() modalID: string = "modalAviso";
  @Output() onModalClose = new EventEmitter();

  constructor(private utilService: UtilService,
              private sigaSeuPlanoService: SigaSeuPlanoService) {}

  ngOnInit() {
  }

  init(aviso: any) {
    this.aviso = aviso;

    this.arquivos = [];

    if (this.aviso.COD_ARQ_GRUPO != null) {
      this.listarArquivos(this.aviso.COD_ARQ_GRUPO);
    }
  }

  listarArquivos(codArqGrupo) {

    this.sigaSeuPlanoService
      .ListarArquivos(codArqGrupo)
      .subscribe(
        (res: any) => {
          this.arquivos = res;
        }
      )
  }

  fecharModal() {
    $('#' + this.modalID).modal('hide');
    this.onModalClose.emit(true);
  }

  download(hashCordArq: string, nome: string) {

    this.sigaSeuPlanoService
      .DownloadArquivo(hashCordArq)
      .subscribe(fileData => this.utilService.salvarArquivo(fileData, nome));
  }

}
